export default __webpack_public_path__ + "static/media/spot-logo.c3bc5a28.svg";